import generateUtilityClass from "../generateUtilityClass";
import generateUtilityClasses from "../generateUtilityClasses";
export function getBackdropUtilityClass(slot) {
    return generateUtilityClass("MuiBackdrop", slot);
}
const backdropUnstyledClasses = generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
export default backdropUnstyledClasses;
